import { G } from "../../constants/theme";

export default function BodyText({ children, center }) {
  return (
    <p
      style={{
        fontSize: 15,
        color: G.muted,
        maxWidth: 600,
        lineHeight: 1.75,
        marginBottom: 36,
        ...(center ? { textAlign: "center", margin: "0 auto 36px" } : {}),
      }}
    >
      {children}
    </p>
  );
}
